import React, { useEffect } from "react";
import { IAgreementState } from "../../../../redux/types/IAgreementState";
import { Empty, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import IMembersPortalComponentDataItem from "../../../../redux/types/IMembersPortalComponentDataItem";
import { CANCEL_SORTING, NO_DATA, SORT_ASCENDING, SORT_DESCENDING } from "../../../Consts";

interface IDraftAgreementsApplicableWorkReviewProps {
    agreement: IAgreementState;
    draftAgreementMaintenanceGeneralDataViewData: IMembersPortalComponentDataItem;
}

const DraftAgreementsApplicableWorkReview: React.FC<IDraftAgreementsApplicableWorkReviewProps> = ({
    agreement,
    draftAgreementMaintenanceGeneralDataViewData
}) => {
    const [worksData, setWorksData] = React.useState([]);
    const [viewData, setViewData] = React.useState([])

    useEffect(() => {
  
      if (agreement?.agreementWorks) {
        const dataSource = agreement.agreementWorks.map((work, index) => ({
          key: index,
          workName: work?.workName?.value ? work.workName.value : "",
          workNumber: work?.workNumber?.value ? work.workNumber.value : "",
      }));
    setWorksData(dataSource)
    }
    }, [agreement]);

    useEffect(() => {
        if (draftAgreementMaintenanceGeneralDataViewData?.fields) {
            const visibleFields = draftAgreementMaintenanceGeneralDataViewData.fields.filter(field => !field.hidden);
            let newViewData = [];
            visibleFields.forEach(item => {
                newViewData[item.name] = item.data;
            });
            setViewData(newViewData);
        }
    
    }, [agreement, draftAgreementMaintenanceGeneralDataViewData]);
  
      const columns: ColumnsType<any>  = [
          {
              title: viewData['workTitle'] || 'Work Title',
              dataIndex: 'workName',
              width: 600,
              key: 'workName',
            },
            {
              title: viewData['workNumber'] || 'Work Number',
              dataIndex: 'workNumber',
              key: 'workNumber',
            },
  ]

  
      return <div>
                    <div className="headerContainer">
            <div
                className={["headerSection", "activeSection"].join(" ")}
                key={'Applicable Works'}
                data-testid={'Applicable Works' + "-section"}
            >
                {viewData['draftAgreementReviewApplicableWorks']}
            </div>
        </div>
        <div className='applicableWorkReviewTable'>
          <Table 
            dataSource={worksData}
            columns={columns} 
            locale={{
            emptyText: (
                <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={viewData[NO_DATA]}
                />
            ),
            triggerDesc: viewData[SORT_DESCENDING],
            triggerAsc: viewData[SORT_ASCENDING],
            cancelSort: viewData[CANCEL_SORTING],
          }}
          />
          </div>
      </div> 
}

export default DraftAgreementsApplicableWorkReview;